// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8e76a397","453":"d34809cb"}[chunkId] + ".chunk.js";
};